// extracted by mini-css-extract-plugin
export var section = "styles-module--section--PnIy-";
export var container = "styles-module--container--3lUv3";
export var innerContainer = "styles-module--innerContainer--3HFjR";
export var image = "styles-module--image--1_lPk";
export var formContainer = "styles-module--formContainer--bRWXn";
export var title = "styles-module--title--1M2-x";
export var splitLeft = "styles-module--splitLeft--2bsmv";
export var splitRight = "styles-module--splitRight--28rnQ";